export default "__VITE_ASSET__BAEW04ZV__"